var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClasses,attrs:{"id":"app"}},[(_vm.showMainNav)?_c('side-bar-navigation',{staticClass:"full-height",attrs:{"id":"main-menu","items":_vm.items}}):_vm._e(),_c('router-view',{staticClass:"page"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }